import React, { useState, useEffect, useRef } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// Removed LoginSignupModal import
import "./Checkout.css";

const StripeCheckoutForm = () => {
    const stripe: any = useStripe();
    const elements: any = useElements();
    const [email, setEmail] = useState('');
    const [fullName, setFullName] = useState('');
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState<{ email: string; fullName: string } | null>(null);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showLoginRequired, setShowLoginRequired] = useState(false);
    const loginRequiredTimeout = useRef<NodeJS.Timeout | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            try {
                const parsed = JSON.parse(userData);
                setUser({ email: parsed.email, fullName: parsed.fullName });
                setEmail(parsed.email);
                setFullName(parsed.fullName);
            } catch {
                setUser(null);
            }
        } else {
            setUser(null);
            setEmail('');
            setFullName('');
        }
    }, []);

    useEffect(() => {
        if (showLoginRequired) {
            loginRequiredTimeout.current = setTimeout(() => {
                setShowLoginRequired(false);
            }, 10000);
        }
        return () => {
            if (loginRequiredTimeout.current) clearTimeout(loginRequiredTimeout.current);
        };
    }, [showLoginRequired]);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setErrorMessage("");
        if (!stripe || !elements) return;
        if (!user) {
            setShowLoginRequired(true);
            return;
        }
        if (!email || !fullName) {
            setErrorMessage('Please fill in all required fields.');
            return;
        }
        setLoading(true);
        try {
            const { error: submitError } = await elements.submit();
            if (submitError?.message) {
                setErrorMessage(submitError.message);
                setLoading(false);
                return;
            }
            // Call backend to create payment intent
            const token = localStorage.getItem('token');
            const response = await axios.post('https://nova-media-backend.vercel.app/api/stripe/createPaymentIntent', {
                email,
                fullName,
                price: 49900 ,
                // price:100,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { 'Authorization': 'Bearer ' + token } : {})
                }
            });
            const clientSecret = response.data?.clientSecret;
            if (!clientSecret) {
                setErrorMessage('Failed to get payment information.');
                setLoading(false);
                return;
            }
            // Now confirm the payment
            setLoading(false);
            try {
                const { error, paymentIntent } = await stripe.confirmPayment({
                    clientSecret,
                    elements,
                    confirmParams: {
                        return_url: "https://viralagencymethod.com/congrats",
                        payment_method_data: {
                            billing_details: {
                                name: fullName,
                                email: email,
                            },
                        },
                    },
                });
                if (error) {
                    setErrorMessage(error.message || 'Payment failed.');
                    setLoading(false);
                    return;
                }
            } catch (err: any) {
                setErrorMessage(err?.message || 'An error occurred during payment confirmation.');
            } finally {
                setLoading(false);
            }
        } catch (err: any) {
            setErrorMessage(err?.response?.data?.message || err.message || 'An error occurred.');
            setLoading(false);
        }
    };

    return (
        <>
          <form onSubmit={handleSubmit}>
            <input
                type="email"
                placeholder="Email Address"
                className="form-input"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                readOnly={!!user}
                style={user ? { background: '#f6f6f6', color: '#888', cursor: 'not-allowed' } : {}}
            />
            <input
                type="text"
                placeholder="Full Name"
                className="form-input"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                required
                readOnly={!!user}
                style={user ? { background: '#f6f6f6', color: '#888', cursor: 'not-allowed' } : {}}
            />
            <div className="form-group">
                <PaymentElement options={{layout: 'tabs'}} />
            </div>
            <button
                disabled={!stripe || !elements || loading}
                type="submit"
                className="submit-button"
                onClick={e => {
                  if (!user) {
                    e.preventDefault();
                    setShowLoginRequired(true);
                  }
                }}
            >
                {loading ? (
                  <>
                    <span className="spinner" style={{
                      display: 'inline-block',
                      width: 20,
                      height: 20,
                      border: '3px solid #f3f3f3',
                      borderTop: '3px solid #f7b731',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginRight: 10,
                      verticalAlign: 'middle',
                    }} />
                    Processing...
                  </>
                ) : 'Complete my purchase'}
            </button>
            {errorMessage && <div className="error-message">{errorMessage}</div>}
        </form>
        {/* Login Required Modal */}
        {showLoginRequired && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.32)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 3000,
          }}>
            <div style={{
              background: '#fffbe7',
              borderRadius: 16,
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              padding: '32px 24px 24px 24px',
              minWidth: 300,
              maxWidth: 340,
              width: '90vw',
              fontFamily: 'Inter, Arial, sans-serif',
              position: 'relative',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              <button onClick={() => setShowLoginRequired(false)} aria-label="Close" style={{
                position: 'absolute',
                top: 12,
                right: 16,
                background: 'none',
                border: 'none',
                fontSize: 22,
                color: '#f7b731',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>&#10005;</button>
              <div style={{ fontWeight: 700, fontSize: '1.2rem', color: '#b48a00', marginBottom: 12 }}>
                Please login before making a payment.
              </div>
              <div style={{ color: '#555', fontSize: '1rem', marginBottom: 10 }}>
                You must be logged in to complete your purchase.
              </div>
              <button
                style={{
                  background: '#f7b731',
                  color: '#222',
                  border: 'none',
                  borderRadius: 8,
                  padding: '10px 0',
                  width: '100%',
                  fontWeight: 700,
                  fontSize: '1.08rem',
                  marginTop: 10,
                  cursor: 'pointer',
                  boxShadow: '0 2px 8px rgba(25,118,210,0.10)',
                  transition: 'background 0.2s',
                }}
                onClick={() => {
                  setShowLoginRequired(false);
                  navigate('/login-signup');
                }}
              >
                Login / Signup
              </button>
            </div>
          </div>
        )}
        <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        `}</style>
      </>
    );
};

export default StripeCheckoutForm; 